import React from "react";
import { Helmet } from "react-helmet";
// import FarmersSection from "./FarmersSection";
import Footer from "../../components/common/Footer";
import ProductShowcase from "../../components/common/ProductShowcase";
import ProductsSection from "../UtpannProduction/ProductsSection";
import TestimonialPage from "../PressReleaseGallery/TestimonialSection";

const ProductDetails4 = () => {
  const utpannSuperData = {
    title: "Utpann Super",
    category: "Liquid Fermented Organic Manure (FOM)",
    image: "/assets/Product/img4.png",
    description:
      "UTPANN Super is a sulphur-rich fertilizer that effectively corrects sulphur deficiency and improves overall plant nutrition. It enhances oil content and quality in oilseed crops while supporting healthy growth and higher yields.",
    price: "350",
    priceNote: "Per 1 ltr Bottle (Gujarat) (Inc GST)",
    recommendations: ["All Crops", "Improve Oil Content & Quality", "Greenery"],
    specsTitle: "FCO-1985 Technical Specifications :",
    specs: [
      { label: "Moisture% by weight maximum", value: "90-97%" },
      { label: "Total Organic Carbon minimum", value: "1.5%" },
      { label: "pH", value: "6.0-8.4" },
      { label: "Electrical Conductivity", value: "Not more than 4.0" },
      { label: "Pathogens", value: "Nil" },
    ],
    packaging: [
      { label: "Bulk Bags", value: "1000ltr IBC" },
      { label: "Standard Pack", value: "1ltr / 5ltr" },
      { label: "Tanker", value: "20kl & 40kl available" },
      { label: "Minimum Order", value: "1 metric ton" },
      { label: "Custom Packaging", value: "Available on request" },
    ],
    benefits: [
      "Corrects sulphur deficiency for balanced plant nutrition",
      "Increases oil content and quality in oilseed crops",
      "Improves crop growth, colour, and protein synthesis",
      "Enhances yield and overall crop performance",
    ],
  };
  return (
    <>
      <Helmet>
        <title>
          Utpann Production - Organic Bio-Fertilizer & Kesari Phos Products |
          Gujarat
        </title>
        <meta
          name="description"
          content="Utpann Production offers premium organic bio-fertilizers including Kesari Phos variants. 50k+ annual volume, 15+ manufacturing partners serving sustainable farming across Gujarat, India."
        />
        <meta
          property="og:title"
          content="Utpann Production - Organic Bio-Fertilizer & Kesari Phos Products | Gujarat"
        />
        <meta
          property="og:description"
          content="Utpann Production offers premium organic bio-fertilizers including Kesari Phos variants. 50k+ annual volume, 15+ manufacturing partners serving sustainable farming across Gujarat, India."
        />
      </Helmet>

      <main>
        <ProductShowcase productData={utpannSuperData} />
        <div className="relative ">
          {/* Product Image Placeholder */}
          <img
            src="/assets/Product/Soil.png"
            alt={"Soil"}
            className="w-full h-auto object-contain"
          />
        </div>
        <ProductsSection />
        {/* <FarmersSection /> */}
        <TestimonialPage />
        <Footer />
      </main>
    </>
  );
};

export default ProductDetails4;
